import { render, staticRenderFns } from "./stack-polarBar.md?vue&type=template&id=517c4c52&"
import script from "./stack-polarBar.md?vue&type=script&lang=js&"
export * from "./stack-polarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517c4c52')) {
      api.createRecord('517c4c52', component.options)
    } else {
      api.reload('517c4c52', component.options)
    }
    module.hot.accept("./stack-polarBar.md?vue&type=template&id=517c4c52&", function () {
      api.rerender('517c4c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/PolarBar/stack-polarBar.md"
export default component.exports